<template>
    <div style="font-size: 16px;">
        轮播图
    </div>
    <div class="riperpo">
        <table>
            <thead>
                <tr>
                    <th style="width: 80px;">序号</th>
                    <th style="width: 180px;">图片</th>
                    <th>链接</th>
                    <th>编辑时间</th>
                    <th>操作</th>
                </tr>
            </thead>
            <tbody v-infinite-scroll="loads" :infinite-scroll-immediate="false">
                <tr v-for="(item, index) in viplist" :key="index">
                    <td style="width: 80px;"> 

                        <div>{{ index + 1 }}</div>
                    </td>
                    <td style="width: 180px;">
                        <div style="color: #1890FF;">
                            <img style="width: 139px;height: 48px;" :src="item.indexImg" alt="">
                            <!-- &nbsp; {{ item.carousel == 1 ? '展示中' : '' }} -->
                        </div>
                    </td>
                    <td style="font-size: 14px;color: #1890FF;">
                        <div style="width: 100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
                            {{ item.detail || '未填写链接'}}

                        </div>

                    </td>
                    <td>
                        {{time(item.addtime)  }}
                    </td>
                    <td>
                        <div @click="xiugai(item)">修改</div>
                        <div @click="handleClose(item.id)">删除</div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <yc-mask ref="maskRef" :close-on-click-modal="false">
        <div class="dialog">
            <div class="dialogt">z
                <div>
                    添加轮播图片
                </div>
                <div @click="closeDialog">
                    <el-icon>
                        <Close />
                    </el-icon>
                </div>
            </div>
            <div class="lianjie">图片链接</div>
            <div class="imghttp">
                <img style="width: 22px;height: 22px;" src="../../assets/install/link.png" alt="">
                <input type="text" v-model="detail" placeholder="请填写图片的跳转链接，非必填">
            </div>
            <div class="imgshang">图片上传</div>
            <div class="bengdi">
                <div class="setupimg">
                    <div class="seimg">
                        <input type="file" id="avatar" name="avatar" accept="image/png, image/jpeg" ref="inputRef"
                            @change="tirggerFile($event)" />
                    </div>
                    <div class="jia">
                        <el-icon :size="80" color="#D8D8D8">
                            <Plus />
                        </el-icon>
                    </div>
                    <div class="images" v-if="imgUrl != ''" @click="openImg">
                        <img style="width:100%;height: 100%;" :src="imgUrl" />
                    </div>
                    <div class="tioajian">请上传一张图片，宽度320*高度480，</div>
                </div>
            </div>
            <!-- <div v-if="imgUrl != ''">
                <el-progress :percentage="progres" />
            </div> -->
            <div style="display: flex;justify-content: center;align-items: center;margin-top: 20px;"><el-switch
                    v-model="carousel" /> &nbsp; 是否显示轮播图</div>
            <div class="dotoom">
                <div class="quxioa" @click="closeDialog">取消</div>
                <div class="baochun" @click="addCarousel">保存</div>
            </div>
        </div>

    </yc-mask>
</template>

<script setup>
import storeapi from '@/api/store'
import { ref, onMounted } from 'vue';
import { ElMessageBox, ElMessage } from 'element-plus'
// import {  } from 'element-plus'

import { useRouter } from 'vue-router';
import ycMask from '@/components/mask/mask.vue'
let maskRef = ref(null);

let seachkey = ref('')
let current = ref(1)
let viplist = ref([])
const router = useRouter()
onMounted(() => {
    pageAdmin()
})

const pageAdmin = async () => {
    try {
        let data = {

            "page": {
                "current": current.value,
                "pageSize": 5
            }
        }

        const res = await storeapi.pageCarousel(data)
        viplist.value = res.data.records
        console.log(viplist.value)

    } catch (error) {
        console.log(error)
    }
}
const loads = async () => {
    current.value++
    console.log('current', current.value)

    try {
        let data = {

            "page": {
                "current": current.value,
                "pageSize": 5
            }
        }
        const res = await storeapi.pageCarousel(data)
        console.log(res)
        viplist.value.push(...res.data.records)
    } catch (error) {
        console.log(error)

    }
}
const handleClose = (userid) => {

    let str = String(userid);

    ElMessageBox.confirm('是否要删除该图?')
        .then(() => {

            console.log(222)
            delAdmin(str)
        })
        .catch(() => {
            // catch error
            console.log(22333)
        })
}
let closeDialog = () => {
    maskRef.value.closeMask();
};
const openImg = () => {
    inputRef.value.click();
}
const inputRef = ref(null);

let detail = ref(null)
let imgUrl = ref(null)
let carousel = ref(null)
let progres = ref(0)
let file = ref({})
let carouselsid = ref(null)
let detailUrl = ref(null)
const xiugai = (role) => {
    console.log('role', role)
    detail.value = role.detail
    imgUrl.value = role.indexImg
    detailUrl.value = role.indexImg
    carouselsid.value = role.id

    if (role.carousel) {
        carousel.value = true
    } else {
        carousel.value = false

    }
    maskRef.value.showMask();


}
//上传图片
const addCarousel = async () => {
    const formData = new FormData();
    console.log('imgUrl.value', imgUrl.value)
    let isShowCarousel
    if (carousel.value) {
        isShowCarousel = 1
    } else {
        isShowCarousel = 0

    }
    formData.append('detailUrl', detail.value);
    if (detailUrl.value != imgUrl.value) {
        formData.append('filedata', file.value);
    }
    formData.append('isShowCarousel', isShowCarousel);
    formData.append('carouselId', carouselsid.value);

    // formData.append('isShowCarousel', 1); 
    const res = await storeapi.alterCarousel(formData, progress => {
        console.log(`当前进度为: ${progress}%`);
        progres.value = progress
    })
    if (res.success) {
        ElMessage({
            message: '修改成功。',
            type: 'success',
            duration: '800',
            onClose: () => {
                router.go(0)
            }
        })
    } else {
        ElMessage.error(res.message)
    }
    console.log('progress', res)

}
const tirggerFile = (event) => {
    // console.log(event)
    console.log(inputRef.value);
    file.value = event.target.files[0];
    console.log(file.value)
    // addCarousel(file)
    let url = "";
    var reader = new FileReader();
    if (file.value) {
        reader.readAsDataURL(file.value);
        reader.onload = function (e) {
            url = this.result.substring(this.result.indexOf(",") + 1);
            imgUrl.value = "data:image/png;base64," + url;
            // console.log(imgUrl.value)
            // that.$refs['imgimg'].setAttribute('src','data:image/png;base64,'+url);
        };
    }

}
const delAdmin = async (data) => {

    let a = [data]
    const res = await storeapi.removeCarousel(a)
    router.go(0)
    console.log(res)
}
const time = (times) => {
    let time = times * 1000
    const date = new Date(time);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
}
</script>

<style lang="scss" scoped>
table,
thead,
tbody {
    display: block;
}

thead,
tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
}

.riperpo {
    margin-top: 21px;

    table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;

        thead {

            height: 46px;
            line-height: 46px;
            font-size: 14px;
            font-weight: 400;
            color: #4D585F;

            th {
               

                text-align: left;
                background: #EEEEEE;
                box-sizing: border-box;
            }

            th:first-child {

                border-radius: 8px 0 0 8px;
                padding-left: 24px;
                box-sizing: border-box;
            }

            th:last-child {

                border-radius: 0 8px 8px 0;
            }
        }

        tbody {
            width: 100%;
            height: 450px;
            overflow-y: scroll;
            font-size: 12px;

            tr {
                text-align: center;
                // font-size: 12px;

                font-weight: 400;
                color: #718096;

                td {
                

                    height: 90px;
                    box-sizing: border-box;
                    border-bottom: 1px solid #E9E9E9;
                    padding-top: 24px;
                    vertical-align: middle;
                    text-align: left;

                }

                td:last-child {
                    // font-size: 12px;
                    font-weight: 400;
                    color: #1890FF;

                    div {
                        float: left;
                        cursor: pointer;
                    }

                    div:last-child {
                        margin-left: 33px;
                    }

                }

                td:first-child {
                    padding: 21px 0 0 20px;
                   

                    text-align: left;

                    line-height: 20px;
                    // font-size: 12px;
                    font-weight: 400;
                    color: rgba(0, 0, 0, 0.65);

                    div:last-child {
                        margin-top: 6px;
                        color: rgba(0, 0, 0, 0.45);
                        font-weight: 400;
                    }

                }
            }
        }
    }

}

.dialog {
    position: relative;
    width: 814px;
    height: 555px;
    background: #FFFFFF;
    border-radius: 8px;
    padding: 23px 36px 0 35px;

    .dialogt {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 18px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.88);
        margin-bottom: 13px;

    }

    .lianjie {
        font-size: 14px;
        font-weight: 600;
        color: #718096;
    }

    .imghttp {
        margin-top: 12px;
        width: 100%;
        height: 56px;
        background: #FAFAFA;
        padding-left: 10px;
        display: flex;
        align-items: center;

        input {
            padding-left: 12px;
            font-size: 16px;
            color: #111827;
            outline: none;
            background: transparent;
            border: none;
            outline: medium;
            width: 100%;
            height: 50px;
        }
    }

    .imgshang {
        font-size: 14px;
        font-weight: 600;
        color: #718096;
        margin-top: 13px;
    }

    .bengdi {
        width: 100%;
        height: 221px;
        background: #FAFAFA;
        margin-top: 12px;
        position: relative;

        .setupimg {
            width: 100%;
            height: 100%;


            .images {
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                z-index: 999;
            }

            .jia {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }

            .seimg {

                width: 100%;
                height: 100%;

                input {
                    padding: 0;
                    width: 100%;
                    height: 100%;
                    opacity: 0;
                }
            }

            .tioajian {

                font-size: 11px;
                line-height: 23px;
                text-align: center;
                font-weight: 400;
                color: #718096;
                position: absolute;
                left: 50%;
                top: 156px;
                transform: translate(-50%, 0);
            }
        }
    }

    .dotoom {
        display: flex;
        font-size: 16px;
        font-weight: 600;
        width: 295px;
        justify-content: space-between;
        margin: 30px auto;

        div {
            text-align: center;
            line-height: 48px;
            color: #FFFFFF;
            border-radius: 8px;

        }

        .quxioa {
            width: 108px;
            height: 48px;
            border: 1px solid #979797;
            color: rgba(0, 0, 0, 0.5);
            box-sizing: border-box;
            cursor: pointer;
        }

        .baochun {
            width: 108px;
            height: 48px;
            background: #79AFFF;
            cursor: pointer;

        }

    }



}
</style>